import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetCompanyState, getCompany } from "../../../../store/company/action";
import { resetAccTransState, getAccTrans as onGetAccTranss } from "../../../../store/accTrans/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../../Components/Common/ExportDoc";
import { getBranch, getPaymentMethod } from "../../../../store/actions";

const transTypeData = [
  {
    options: [
      { label: "PENERIMAAN CASH", value: "CASH IN" },
      { label: "PENGELUARAN CASH", value: "CASH OUT" },
      { label: "TRANSFER CASH", value: "CASH TRANSFER" },
      { label: "BIAYA", value: "EXPENSE" },
      { label: "PENJUALAN", value: "SALES" },
      { label: "PEMBELIAN", value: "PURCHASE" },
      { label: "PENDAPATAN", value: "REVENUE" },
      { label: "PIUTANG", value: "RECEIVABLE" },
      { label: "HUTANG", value: "PAYABLE" },
      { label: "LAINNYA", value: "OTHER" },
    ],
  },
];

const ReportTransaction = () => {
  const [pageIdx, setPageIdx] = useState(0);
  const [accTransDoc, setAccTransDoc] = useState([]);
  const dispatch = useDispatch();

  const { accTranss, isAccTransCreated, isAccTransSuccess, loading, error, companies, companyLoading, branches, branchLoading, paymentMethods, paymentMethodLoading } = useSelector((state) => ({
    accTranss: state.AccTrans.accTranss,
    isAccTransCreated: state.AccTrans.isAccTransCreated,
    isAccTransSuccess: state.AccTrans.isAccTransSuccess,
    loading: state.AccTrans.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    paymentMethods: state.PaymentMethod.paymentMethods,
    paymentMethodLoading: state.PaymentMethod.loading,
    error: state.AccTrans.error,
  }));

  const [accTransList, setAccTransList] = useState([]);
  const [accTrans, setAccTrans] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [companyName, setCompanyName] = useState({});

  const [branchList, setBranchList] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [searchBranch, setSearchBranch] = useState("");
  const [searchPaymentMethod, setSearchPaymentMethod] = useState("");
  const [searchType, setSearchType] = useState("");

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    setAccTransList(accTranss);
  }, [accTranss]);

  useEffect(() => {
    if (!isEmpty(accTranss)) setAccTransList(accTranss.map((el) => ({ ...el, isChecked: false })));
  }, [accTranss]);

  useEffect(() => {
    if (!isSearch) {
      dispatch(onGetAccTranss({ id: "1", ok: "ok" }, "/accTrans-daily"));
    }
    setIsSearch(true);
    const obj = JSON.parse(localStorage.getItem("authUser"));
    if (obj.data && obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role) {
      setCompanyName({
        label: obj?.data?.user.user_company.name,
        value: obj?.data?.user.user_company.id,
      });
      setRoles(obj?.data?.user?.user_position?.position_role.method);
    } else setRoles(null);

    if (obj?.data) setUserType(obj?.data?.userType);

    dispatch(getBranch({ companyId: obj.data.companyId, status: 2 }));
    dispatch(getPaymentMethod({ companyId: obj.data.companyId, status: 2 }));
  }, [dispatch, accTranss, isSearch]);

  function handleCompany(e) {
    if (e.length > 2) {
      const param = { title: e, status: 2 };
      dispatch(getCompany(param));
    }
    return false;
  }

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [{ label: "Pilih Cabang", value: null }];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(paymentMethods)) {
      var data = [];
      var opt = [];
      paymentMethods.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPaymentMethodList(data);
    }
    else {
      setPaymentMethodList([]);
    }
  }, [paymentMethods]);

  useEffect(() => {
    setAccTrans(accTranss);
  }, [accTranss]);

  useEffect(() => {
    if (!isEmpty(accTranss)) {
      setAccTrans(accTranss);
    }
  }, [accTranss]);

  useEffect(() => {
    setAccTransList(accTranss);
  }, [accTranss]);

  useEffect(() => {
    if (!isEmpty(accTranss)) setAccTransList(accTranss);
  }, [accTranss]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "accTrans_customer",
        label: "Nama Debitur",
        isSelected: true,
        data: [],
      },
      {
        id: "accTrans_detail_block",
        label: "Blok",
        isSelected: true,
        data: [],
      },
      {
        id: "accTrans_detail_type",
        label: "Type",
        isSelected: true,
        data: [],
      },
      {
        id: "accTrans_applicant",
        label: "Tgl Masuk Bank",
        isSelected: true,
        data: [],
      },
      {
        id: "accTrans_bank_branch",
        label: "Bank",
        isSelected: true,
        data: [],
      },
      {
        id: "accTrans_agent",
        label: "Marketing",
        isSelected: true,
        data: [],
      },
    ];

    if (accTransList.length > 0) {
      accTransList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "accTrans_customer" || doc.id === "accTrans_bank_branch" || doc.id === "accTrans_agent") {
                doc.data.push(value?.name ?? "");
              } else if (doc.id === "accTrans_applicant") {
                doc.data.push(handleValidDate(value?.applicationAt));
              } else {
                doc.data.push(value);
              }
            } else {
              if (key === "accTrans_detail") {
                const blockDoc = dataDoc.find((d) => d.id === "accTrans_detail_block");
                const typeDoc = dataDoc.find((d) => d.id === "accTrans_detail_type");
                blockDoc.data.push(value[0]?.accTrans_detail_product?.product_block?.name ?? "");
                typeDoc.data.push(value[0]?.accTrans_detail_product?.name ?? "");
              }
            }
          });
        }
      });
    }

    setAccTransDoc(dataDoc);
  }, [accTransList]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = accTransList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setAccTransList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = accTransList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setAccTransList(updatedData);
                }} />
            </div>
          );
        },
      },
      {
        Header: "Status",
        accessor: "at_status.name",
        filterable: true,
        Cell: (data) => {
          let stat;
          let statName = data.row.original.at_status && data.row.original.at_status.name;
          switch (statName) {
            case "DRAFT":
              stat = <span className="badge text-uppercase badge-soft-warning">{statName}</span>;
              break;
            case "ACTIVE":
              stat = <span className="badge text-uppercase badge-soft-success">APPROVED</span>;
              break;
            case "INACTIVE":
              stat = <span className="badge text-uppercase badge-soft-danger">CANCELED</span>;
              break;
            default:
              stat = <span className="badge text-uppercase badge-soft-danger">{statName}</span>;
              break;
          }
          let type;
          switch (data.row.original.type) {
            case "CASH IN":
              type = <span className="badge text-uppercase badge-soft-info">{data.row.original.type}</span>;
              break;
            case "REVENUE":
              type = <span className="badge text-uppercase badge-soft-info">{data.row.original.type}</span>;
              break;
            case "RECEIVABLE":
              type = <span className="badge text-uppercase badge-soft-info">{data.row.original.type}</span>;
              break;
            case "CASH TRANSFER":
              type = <span className="badge text-uppercase badge-soft-info">{data.row.original.type}</span>;
              break;
            case "CASH OUT":
              type = <span className="badge text-uppercase badge-soft-warning">{data.row.original.type}</span>;
              break;
            case "EXPENSE":
              type = <span className="badge text-uppercase badge-soft-warning">{data.row.original.type}</span>;
              break;
            case "PAYABLE":
              type = <span className="badge text-uppercase badge-soft-warning">{data.row.original.type}</span>;
              break;
            default:
              type = <span className="badge text-uppercase badge-soft-primary">{data.row.original.type}</span>;
              break;
          }
          return (
            <div className="hstack gap-2">
              {stat}
              {type}
            </div>
          );
        },
      },
      {
        Header: "No Transaksi",
        accessor: "transaction_no",
        filterable: true,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return data.transaction_no;
        },
      },
      {
        Header: "Nilai",
        accessor: "amount",
        filterable: true,
        Cell: (data) => {
          return <span className="fw-semibold fs-14">{currencyFormat(data.row.original.amount)}</span>;
        },
      },
      {
        Header: "Tanggal",
        accessor: "transactionat",
        filterable: true,
        Cell: (data) => {
          return handleValidDate(data.row.original.transactionat);
        },
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
        Cell: (data) => {
          return (
            <div className="">
              <p className="mb-0 text-muted fw-semibold">{data.row.original.at_branch ? data.row.original.at_branch.name : "-"}</p>
              <p className="mb-0">{data.row.original.description}</p>
            </div>
          );
        },
      },
      {
        id: "branch",
        Header: "Cabang",
        accessor: "at_branch.name",
        filterable: true,
      },
      {
        id: "type",
        Header: "Type",
        accessor: "type",
        filterable: true,
      },
    ],
    [accTransList, isCheckAll]
  );


  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = accTransList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setAccTransList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => accTransList, [accTransList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handleAccTransStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      branchId: searchBranch.value ?? "",
      type: searchType.value ?? "",
      paymentMethodId: searchPaymentMethod.value ?? "",
    };
    dispatch(onGetAccTranss(param));
  }

  document.title = "Laporan Tanda Jadi Harian | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={accTransList} />
      <Container fluid>
        <BreadCrumb title="Laporan Transaksi" pageTitle="Laporan Keuangan" />
        <Row>
          <Col lg={12}>
            <Card id="accTransList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Data Laporan &nbsp;
                    {isLoading ? (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    ) : (
                      ""
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <ExportDoc data={accTransDoc} />
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={1}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="search-box me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                            gotoPage(0);
                              }}
                              placeholder={`${count} Cari...`}
                              value={searchValue ?? ""}/>
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <Select
                            name="searchBranch"
                            value={searchBranch}
                            placeholder="Filter Proyek"
                            onChange={(e) => {
                              setSearchBranch(e);
                            }}
                            options={branchList}
                          ></Select>
                        </Col>
                        <Col sm={2}>
                          <Select
                            name="transTypeData"
                            value={searchType}
                            placeholder="Filter Type"
                            onChange={(e) => {
                              setSearchType(e);
                            }}
                            options={transTypeData}
                          ></Select>
                        </Col>
                        <Col sm={2}>
                          <Select
                            name="searchPaymentMethod"
                            value={searchPaymentMethod}
                            placeholder="Filter Metode Pembayaran"
                            onChange={(e) => {
                              setSearchPaymentMethod(e);
                            }}
                            options={paymentMethodList}
                          ></Select>
                        </Col>
                        <Col sm={2}>
                          <div className="search-box me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}/>
                            <i className="bx bx-calendar-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={1}>
                          <div>
                            <button
                              type="button"
                              className="btn btn-light w-100"
                              onClick={() => {
                                handleFilter();
                              }}>
                              <i className="ri-search-line me-1 align-bottom fs-12"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr className={""} key={index} {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">
                      {rows.length} Data
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ReportTransaction;
